// Persona catalogue mirrored from backend for UI styling.
// The backend is the source of truth via GET /api/creative-partner/personas.
//
// Note: persona IDs are historical (novelist/producer/editor/critic/mentor/researcher)
// but their display roles have been rebranded in the backend to: Innovator / Architect
// / Wordsmith / Analyst / Researcher / Progress Coach. Do not rename IDs — existing
// conversations reference them.

export const PERSONA_STYLES = {
  novelist:   { accent: 'text-gold',         ring: 'border-gold/40',           badge: 'bg-gold/10 text-gold',                 hint: 'Claude Sonnet 4.5' }, // Maya · Innovator
  producer:   { accent: 'text-emerald-300',  ring: 'border-emerald-400/40',    badge: 'bg-emerald-400/10 text-emerald-300',   hint: 'GPT-5.2' },            // Alex · Architect
  editor:     { accent: 'text-sky-300',      ring: 'border-sky-400/40',        badge: 'bg-sky-400/10 text-sky-300',           hint: 'Claude Sonnet 4.5' }, // Samantha · Wordsmith
  critic:     { accent: 'text-rose-300',     ring: 'border-rose-400/40',       badge: 'bg-rose-400/10 text-rose-300',         hint: 'GPT-5.2' },            // Lawrence · Analyst
  researcher: { accent: 'text-violet-300',   ring: 'border-violet-400/40',     badge: 'bg-violet-400/10 text-violet-300',     hint: 'Gemini 3 Pro' },       // Keith · Researcher
  mentor:     { accent: 'text-amber-300',    ring: 'border-amber-400/40',      badge: 'bg-amber-400/10 text-amber-300',       hint: 'Claude Sonnet 4.5' }, // Noah · Progress Coach
};

export const PROJECT_TYPE_LABELS = {
  novel: 'Novel',
  short_story: 'Short story',
  script: 'Script',
  tv_format: 'TV format',
  film: 'Film',
  song: 'Song',
  poetry: 'Poetry',
  invention: 'Invention',
  business_idea: 'Business idea',
  game: 'Game',
  educational: 'Educational',
  presentation: 'Presentation',
  speech: 'Speech',
  other: 'Other',
};

export const STAGE_LABELS = {
  idea: 'Idea',
  research: 'Research',
  planning: 'Planning',
  structure: 'Structure',
  writing: 'Writing',
  editing: 'Editing',
  polishing: 'Polishing',
  pitching: 'Pitching',
  completion: 'Completion',
};

export const DEV_JOURNEY = [
  'idea', 'research', 'planning', 'structure', 'writing', 'editing', 'polishing', 'pitching', 'completion',
];
